import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class AnimationService {
  animateValue(element: HTMLElement, start: number, end: number, duration: number = 2000, decimals: number = 0) {
    let startTimestamp: number | null = null;

    const step = (timestamp: number) => {
      if (!startTimestamp) startTimestamp = timestamp;
      const progress = Math.min((timestamp - startTimestamp) / duration, 1);
      
      const easeOutQuart = 1 - Math.pow(1 - progress, 4);
      const currentValue = Math.floor(start + (end - start) * easeOutQuart);
      
      element.textContent = currentValue.toFixed(decimals);

      if (progress < 1) {
        window.requestAnimationFrame(step);
      } else {
        element.textContent = end.toFixed(decimals);
      }
    };

    window.requestAnimationFrame(step);
  }
}